import { Component } from '@angular/core';

@Component({
  selector: 'app-planning-department',
  templateUrl: './planning-department.component.html',
  styles: [],
  standalone: false,
})
export class PlanningDepartmentComponent {}
